import axios from 'axios'

import env from 'global/environments'

const serverUrl = `${env.endpoint}/${env.path}`

const API = axios.create({
  baseURL: serverUrl,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json'
  }
})

console.info(
`vita-verify
platform    = ${env.platform}
environment = ${env.environment}
environment = ${serverUrl}
`)

export default API
